import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FFF",
              d: "M16 2.667c7.364 0 13.333 5.97 13.333 13.333 0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.333-5.97-13.333-13.333C2.667 8.636 8.637 2.667 16 2.667zm0 2C9.74 4.667 4.667 9.74 4.667 16c0 6.26 5.074 11.333 11.333 11.333 6.26 0 11.333-5.074 11.333-11.333C27.333 9.74 22.26 4.667 16 4.667zm0 15.666c.506 0 .925.377.99.865l.01.135v1.334c0 .552-.448 1-1 1-.506 0-.925-.377-.99-.865l-.01-.135v-1.334c0-.552.448-1 1-1zm0-12c.506 0 .925.377.99.865l.01.135v8c0 .553-.448 1-1 1-.506 0-.925-.376-.99-.864l-.01-.136v-8c0-.552.448-1 1-1z",
              transform: "translate(-40 -319) translate(20 300) translate(20 19)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }